__turbopack_context__.v({
  "body": "j48AMa_body",
  "description": "j48AMa_description",
  "descriptionText": "j48AMa_descriptionText",
  "heading": "j48AMa_heading",
  "readMore": "j48AMa_readMore",
  "sheetContent": "j48AMa_sheetContent",
  "title": "j48AMa_title",
  "wrapper": "j48AMa_wrapper",
});
